import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
// 导入全部视频
import sc1 from '../assetsV2/21/sc1.mp4';
import sc2 from '../assetsV2/21/sc2.mp4';
import sc3 from '../assetsV2/21/sc3.mp4';
import sc5 from '../assetsV2/21/sc5.mp4';
import sc9 from '../assetsV2/21/sc9.mp4';
import sc13 from '../assetsV2/21/sc13.mp4';
import sc15 from '../assetsV2/21/sc15.mp4';
import sc20 from '../assetsV2/21/sc20.mp4';
import sc21 from '../assetsV2/21/sc21.mp4';
import sc22 from '../assetsV2/21/sc22.mp4';
import sc23 from '../assetsV2/21/sc23.mp4';
import sc27 from '../assetsV2/21/sc27.mp4';
import sc28 from '../assetsV2/21/sc28.mp4';
import sc29 from '../assetsV2/21/sc29.mp4';
import sc32 from '../assetsV2/21/sc32.mp4';
import sc33 from '../assetsV2/21/sc33.mp4';
import sc36 from '../assetsV2/21/sc36.mp4';
import sc38 from '../assetsV2/21/sc38.mp4';
import sc39 from '../assetsV2/21/sc39.mp4';
import SC40 from '../assetsV2/21/SC40.mp4';
import SC42 from '../assetsV2/21/SC42.mp4';
import sc43 from '../assetsV2/21/sc43.mp4';
import sc45 from '../assetsV2/21/sc45.mp4';
import sc50 from '../assetsV2/21/sc50.mp4';
import sc191 from '../assetsV2/21/sc191.mp4';
// 导入全部封面图片
import sc1Cover from '../assetsV2/21/covers/sc1.jpg';
import sc2Cover from '../assetsV2/21/covers/sc2.jpg';
import sc3Cover from '../assetsV2/21/covers/sc3.jpg';
import sc5Cover from '../assetsV2/21/covers/sc5.jpg';
import sc9Cover from '../assetsV2/21/covers/sc9.jpg';
import sc13Cover from '../assetsV2/21/covers/sc13.jpg';
import sc15Cover from '../assetsV2/21/covers/sc15.jpg';
import sc20Cover from '../assetsV2/21/covers/sc20.jpg';
import sc21Cover from '../assetsV2/21/covers/sc21.jpg';
import sc22Cover from '../assetsV2/21/covers/sc22.jpg';
import sc23Cover from '../assetsV2/21/covers/sc23.jpg';
import sc27Cover from '../assetsV2/21/covers/sc27.jpg';
import sc28Cover from '../assetsV2/21/covers/sc28.jpg';
import sc29Cover from '../assetsV2/21/covers/sc29.jpg';
import sc32Cover from '../assetsV2/21/covers/sc32.jpg';
import sc33Cover from '../assetsV2/21/covers/sc33.jpg';
import sc36Cover from '../assetsV2/21/covers/sc36.jpg';
import sc38Cover from '../assetsV2/21/covers/sc38.jpg';
import sc39Cover from '../assetsV2/21/covers/sc39.jpg';
import SC40Cover from '../assetsV2/21/covers/SC40.jpg';
import SC42Cover from '../assetsV2/21/covers/SC42.jpg';
import sc43Cover from '../assetsV2/21/covers/sc43.jpg';
import sc45Cover from '../assetsV2/21/covers/sc45.jpg';
import sc50Cover from '../assetsV2/21/covers/sc50.jpg';
import sc191Cover from '../assetsV2/21/covers/sc191.jpg';


const allVideos = [
  sc1, sc2, sc3, sc5, sc9, sc13, sc15, sc20, sc21, sc22, sc23, sc27, sc28, sc29,
  sc32, sc33, sc36, sc38, sc39, SC40, SC42, sc43, sc45, sc50, sc191
];

// 所有封面图，与视频顺序一一对应
const allCovers = [
  sc1Cover, sc2Cover, sc3Cover, sc5Cover, sc9Cover, sc13Cover, sc15Cover, sc20Cover, sc21Cover, sc22Cover, sc23Cover, sc27Cover, sc28Cover, sc29Cover,
  sc32Cover, sc33Cover, sc36Cover, sc38Cover, sc39Cover, SC40Cover, SC42Cover, sc43Cover, sc45Cover, sc50Cover, sc191Cover
];

// 视频与封面一一配对
const pairedAssets = allVideos.map((video, index) => ({
  video,
  cover: allCovers[index]
}));

// 随机选取 n 个成对资源
function getRandomPairs(pairs, n) {
  const result = [];
  const used = new Set();
  while (result.length < n && used.size < pairs.length) {
    const idx = Math.floor(Math.random() * pairs.length);
    if (!used.has(idx)) {
      result.push(pairs[idx]);
      used.add(idx);
    }
  }
  // 补齐不足
  while (result.length < n) {
    result.push(pairs[result.length % pairs.length]);
  }
  return result;
}

const selectedPairs = getRandomPairs(pairedAssets, 21);


const TARGET_FPS = 30;
const FRAME_DURATION = 1000 / TARGET_FPS;

const config = {
  speed: 0.001,
  radius: 45,
  height: 55,
  cols: 7,
  rows: 3,
  gapX: 20,
  gapY: 40,
  loopGap: 20,
  uvScale: 1,
  images: selectedPairs.map(pair => pair.video),
  covers: selectedPairs.map(pair => pair.cover)
};
const getResponsiveConfig = () => {
  const width = window.innerWidth;
  const minWidth = 375;  // 最小屏幕宽度
  // 线性插值函数
  const lerp = (min, max, t) => {
    const ratio = (width - minWidth) / (1920 - minWidth);
    return width <= 1920
      ? min + (max - min) * Math.max(0, Math.min(1, ratio))
      : max * (1 + (width - 1920) / 1920 * 0.5);
  };
  return {
    ...config,
    radius: lerp(25, 45),
    height: lerp(20, 28),
    gapX: lerp(20, 60),
    gapY: lerp(50, 100),
    loopGap: lerp(10, 60)
  };
};

const CylinderScroll = ({ onScreen }) => {
  const containerRef = useRef();
  const scene = useRef(new THREE.Scene());
  const camera = useRef(null);
  const renderer = useRef(null);
  const texture = useRef(null);
  const animateId = useRef(0);
  const videoElements = useRef({}); // 只存可见cell的video
  const texturesLoaded = useRef(0);
  const savedOffset = useRef(0);
  const resizeTimer = useRef(null);
  const cylinderMesh = useRef(null);
  const coverImageElements = useRef([]); // 缓存 HTMLImageElement

  // 初始化封面图片元素
  useEffect(() => {
    if (coverImageElements.current.length === 0) {
      config.covers.forEach((coverUrl, idx) => {
        const img = new window.Image();
        img.src = coverUrl;
        coverImageElements.current[idx] = img;
      });
    }
  }, []);

  // 获取当前可见三列索引
  function getVisibleCols(textureOffset, cols) {
    const colWidth = 1 / cols;
    let centerCol = Math.round((textureOffset % 1) / colWidth);
    if (centerCol < 0) centerCol += cols;
    return [
      centerCol,
      (centerCol + 1) % cols,
      (centerCol - 1 + cols) % cols
    ];
  }

  // 只为可见cell创建video，其余用图片
  function updateVisibleVideos(visibleIndices) {
    const { images } = config;
    visibleIndices.forEach(idx => {
      if (!videoElements.current[idx]) {
        const video = document.createElement('video');
        video.src = images[idx];
        video.loop = true;
        video.muted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.crossOrigin = 'anonymous';
        video.oncanplaythrough = () => video.play();
        video.load();
        videoElements.current[idx] = video;
      }
    });
    // 销毁不再可见的video
    Object.keys(videoElements.current).forEach(key => {
      const idx = Number(key);
      if (!visibleIndices.includes(idx)) {
        const video = videoElements.current[idx];
        if (video) {
          video.pause();
          video.src = '';
          video.load();
          video.remove();
        }
        delete videoElements.current[idx];
      }
    });
  }

  // 创建纹理
  const createTexture = () => {
    const { cols, rows, gapX, gapY, loopGap } = config;
    const imgWidth = 160;
    const imgHeight = 160;
    const canvasWidth = cols * imgWidth + (cols - 1) * gapX + loopGap;
    const canvasHeight = rows * imgHeight + (rows - 1) * gapY;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { alpha: true });
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    // 初始只创建可见列的视频
    const visibleCols = getVisibleCols(0, config.cols);
    const visibleIndices = [];
    for (let row = 0; row < config.rows; row++) {
      for (const col of visibleCols) {
        visibleIndices.push(row * config.cols + col);
      }
    }
    updateVisibleVideos(visibleIndices);
    texturesLoaded.current = config.images.length;
    checkTexturesLoaded(ctx, canvas);
  };

  // 检查所有资源是否加载完成
  const checkTexturesLoaded = (ctx, canvas) => {
    if (texturesLoaded.current === config.images.length) {
      setTimeout(() => {
        animateCanvas(ctx, canvas);
      }, 3200);
    }
  };

  // 画布动画
  const animateCanvas = (ctx, canvas) => {
    const renderFrame = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const { cols, rows, gapX, gapY } = config;
      const imgWidth = 160;
      const imgHeight = 160;
      const offsetX = texture.current ? texture.current.offset.x : 0;
      const visibleCols = getVisibleCols(offsetX, cols);
      const visibleIndices = [];
      for (let row = 0; row < rows; row++) {
        for (const col of visibleCols) {
          visibleIndices.push(row * cols + col);
        }
      }
      updateVisibleVideos(visibleIndices);
      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          const idx = row * cols + col;
          const x = col * (imgWidth + gapX);
          const y = row * (imgHeight + gapY);
          const video = videoElements.current[idx];
          const img = coverImageElements.current[idx];
          if (video && video.readyState >= 2) {
            ctx.drawImage(video, x, y, imgWidth, imgHeight);
          } else if (img && img.complete) {
            ctx.drawImage(img, x, y, imgWidth, imgHeight);
          }
        }
      }
      if (texture.current) {
        texture.current.needsUpdate = true;
      }
      animateId.current = requestAnimationFrame(renderFrame);
    };
    if (!texture.current) {
      texture.current = new THREE.CanvasTexture(canvas);
      texture.current.wrapS = THREE.RepeatWrapping;
      texture.current.wrapT = THREE.RepeatWrapping;
      texture.current.minFilter = THREE.LinearFilter;
      texture.current.magFilter = THREE.LinearFilter;
      texture.current.anisotropy = Math.min(4, renderer.current.capabilities.getMaxAnisotropy());
      createCylinder();
    }
    renderFrame();
  };

  // 只创建一次 Cylinder，resize 时只更新参数
  const createCylinder = (currentConfig = getResponsiveConfig()) => {
    if (cylinderMesh.current) {
      const geometry = new THREE.CylinderGeometry(
        currentConfig.radius,
        currentConfig.radius,
        currentConfig.height,
        64,
        1,
        true,
        Math.PI / 2,
        Math.PI
      );
      const uvArray = geometry.attributes.uv.array;
      for (let i = 0; i < uvArray.length; i += 2) {
        uvArray[i] *= 1.2;
      }
      geometry.attributes.uv.needsUpdate = true;
      cylinderMesh.current.geometry.dispose();
      cylinderMesh.current.geometry = geometry;
      return;
    }
    const geometry = new THREE.CylinderGeometry(
      currentConfig.radius,
      currentConfig.radius,
      currentConfig.height,
      64,
      1,
      true,
      Math.PI / 2,
      Math.PI
    );
    const uvArray = geometry.attributes.uv.array;
    for (let i = 0; i < uvArray.length; i += 2) {
      uvArray[i] *= 1.2;
    }
    geometry.attributes.uv.needsUpdate = true;
    const material = new THREE.MeshBasicMaterial({
      map: texture.current,
      side: THREE.BackSide,
    });
    const cylinder = new THREE.Mesh(geometry, material);
    scene.current.add(cylinder);
    cylinderMesh.current = cylinder;
  };

  // 动画循环
  const startAnimation = () => {
    if (animateId.current) return;
    let lastFrameTime = performance.now();
    const animate = (now) => {
      if (!containerRef.current) return;
      animateId.current = requestAnimationFrame(animate);
      if (now - lastFrameTime < FRAME_DURATION) {
        return;
      }
      lastFrameTime = now;
      if (texture.current) {
        texture.current.offset.x -= config.speed;
        if (texture.current.offset.x <= -1) texture.current.offset.x = 0;
      }
      renderer.current.render(scene.current, camera.current);
    };
    animate(performance.now());
  };

  // 窗口尺寸调整
  const handleResize = () => {
    if (texture.current) {
      savedOffset.current = texture.current.offset.x;
    }
    clearTimeout(resizeTimer.current);
    resizeTimer.current = setTimeout(() => {
      const currentConfig = getResponsiveConfig();
      const containerWidth = window.innerWidth;
      const containerHeight = Math.min(window.innerHeight, 1000);
      renderer.current.setSize(containerWidth, containerHeight);
      camera.current.aspect = window.innerWidth / window.innerHeight;
      renderer.current.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      camera.current.position.z = currentConfig.radius * 1.2;
      camera.current.updateProjectionMatrix();
      createCylinder(currentConfig);
      if (texture.current) {
        texture.current.offset.x = savedOffset.current;
      }
    }, 200);
  };

  useEffect(() => {
    const containerWidth = window.innerWidth;
    const containerHeight = Math.min(window.innerHeight, 1000);
    camera.current = new THREE.PerspectiveCamera(43,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    camera.current.position.set(0, 0, 43);
    renderer.current = new THREE.WebGLRenderer({
      antialias: true,
      alpha: true,
      powerPreference: 'high-performance',
      precision: 'mediump',
      preserveDrawingBuffer: false
    });
    renderer.current.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.current.setSize(containerWidth, containerHeight);
    containerRef.current.appendChild(renderer.current.domElement);
    createTexture();
    startAnimation();
    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(resizeTimer.current);
      cancelAnimationFrame(animateId.current);
      animateId.current = 0;
      window.removeEventListener('resize', handleResize);
      Object.values(videoElements.current).forEach(video => {
        if (video) {
          video.pause();
          video.src = '';
          video.load();
          video.remove();
        }
      });
      videoElements.current = {};
      savedOffset.current = 0;
      if (renderer.current) {
        renderer.current.dispose();
        scene.current.clear();
        texture.current?.dispose();
        if (cylinderMesh.current) {
          cylinderMesh.current.geometry.dispose();
          cylinderMesh.current.material.dispose();
          scene.current.remove(cylinderMesh.current);
          cylinderMesh.current = null;
        }
        if (renderer.current.domElement && containerRef.current) {
          containerRef.current.removeChild(renderer.current.domElement);
        }
      }
    };
  }, []);
  return (<div ref={containerRef} />);
};

export default CylinderScroll;